import * as React from 'react';
import { 
    Menu as MaterialUIMenu,
    MenuItem,
    Button,
    Fade
} from '@material-ui/core'
import iconDownArrowDarkDownSvg from 'assets/icons/icon-arrow-down-aqua.svg'
import iconDownArrowDarkUpSvg from 'assets/icons/icon-arrow-up-aqua.svg'
import { getToken } from 'core/libs/lib-token-helpers'
import { styles } from './styles.scss'

const ITEM_HEIGHT = 18
export default function TokenMenu(props) {
    const { children } = props
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)
    const handleClick = (event) => { setAnchorEl(event.currentTarget) }
    const handleClose = (event) => {
        setAnchorEl(null)
        const selectedCurrency = event.target.dataset.currency 
        const selectedCurrencyElem = event.currentTarget
        props.onClose(selectedCurrency, selectedCurrencyElem)
    }
    const arrowIcon = open ? (<img src={iconDownArrowDarkUpSvg}/>) : (<img src={iconDownArrowDarkDownSvg} />)

    return (
        <div className={`menu ${styles}`}>
            <Button
                id="fade-button"
                aria-controls={open ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <div>
                    {children}
                    <span className="down-arrow-icon">
                        {arrowIcon}
                    </span>
                </div>
            </Button>
            <MaterialUIMenu
                id="long-menu"
                className={styles}
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
                slotprops={{
                    paper: {
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: '20ch',
                        }
                    }
                }}
            >
                <MenuItem data-currency="weth" selected={true} onClick={handleClose}>
                    <img width="20" src={getToken("wethToken")} />WETH
                </MenuItem>
                <MenuItem data-currency="dai" onClick={handleClose}>
                    <img width="20" src={getToken("daiToken")} />DAI
                </MenuItem>
                <MenuItem data-currency="usdt" onClick={handleClose}>
                    <img width="20" src={getToken("usdtToken")} />USDT
                </MenuItem>
                {/* <MenuItem data-currency="reth" onClick={handleClose}>
                    <img width="20" src={getToken("rethToken")} />RETH
                </MenuItem> */}
                <MenuItem data-currency="usdc" onClick={handleClose}>
                    <img width="20" src={getToken("usdcToken")} />USDC
                </MenuItem>
                {/* <MenuItem data-currency="wsteth" onClick={handleClose}>
                    <img width="20" src={getToken("wstethToken")} />WSTETH
                </MenuItem>
                <MenuItem data-currency="usds" onClick={handleClose}>
                    <img width="20" src={getToken("usdsToken")} />USDS
                </MenuItem>
                <MenuItem data-currency="uni" onClick={handleClose}>
                    <img width="20" src={getToken("uniToken")} />UNI
                </MenuItem>
                <MenuItem data-currency="wbtc" onClick={handleClose}>
                    <img width="20" src={getToken("wbtcToken")} />WBTC
                </MenuItem> */}
                <MenuItem data-currency="eth" onClick={handleClose}>
                    <img width="20" src={getToken("ethToken")} />ETH
                </MenuItem>
                {/* <MenuItem data-currency="ldo" onClick={handleClose}>
                    <img width="20" src={getToken("lidoToken")} />LDO
                </MenuItem>
                <MenuItem data-currency="link" onClick={handleClose}>
                    <img width="20" src={getToken("linkToken")} />LINK
                </MenuItem> */}
                <MenuItem data-currency="mkr" onClick={handleClose}>
                    <img width="20" src={getToken("mkrToken")} />MKR
                </MenuItem>
                <MenuItem data-currency="comp" onClick={handleClose}>
                    <img width="20" src={getToken("compToken")} />COMP
                </MenuItem>
                {/* <MenuItem data-currency="arb" onClick={handleClose}>
                    <img width="20" src={getToken("arbToken")} />ARB
                </MenuItem> */}
                {/* <MenuItem data-currency="weeth" onClick={handleClose}>
                    <img width="20" src={getToken("weethToken")} />WEETH
                </MenuItem> */}
                {/* <MenuItem data-currency="usde" onClick={handleClose}>
                    <img width="20" src={getToken("usdeToken")} />USDE
                </MenuItem>
                <MenuItem data-currency="cbbtc" onClick={handleClose}>
                    <img width="20" src={getToken("cbbtcToken")} />CBBTC
                </MenuItem> */}
            </MaterialUIMenu>
        </div>
    )
}